<template>
  <v-card>
    <v-card-title class="headline" primary-title> {{ action == 'Create' ? 'Create New Bot' : `Update ${bot.title}` }} </v-card-title>
    <v-card-text>
      <v-text-field
        v-model="form.name"
        placeholder="Bot Name"
        type="text"
        label="Bot Name"
        flat
      ></v-text-field>
      <image-input :url="form.image" @onImageUpload="updateImageUrl" />

      <Voices label="Select Your Agent's Voice" v-model="form.voice_id" class="my-3" />

      <div>
        <v-subheader class="pl-0 flex justify-space-between" style="margin-bottom: -10px;margin-top:-26px"><span>Speed</span> <span>{{form.speed}}</span></v-subheader>
        <v-slider
          v-model="form.speed"
          min=".50"
          step=".01"
          max="1"
          thumb-label
          ticks
          class="mt-0"
        ></v-slider>
      </div>
      <v-combobox
          v-model="form.language"
          :items="languages"
          label="Select Agent's Languages"
          multiple
          clearable
          :return-object="false"
        ></v-combobox>

        <v-combobox
          v-model="form.dialect"
          :items="dialects"
          :disabled="!form.language.length"
          label="Select Agent's Dialects"
          multiple
          clearable
          item-disabled="disabled"
          :return-object="false"
        ></v-combobox>

        <v-textarea
          v-model="form.ai_greeting"
          placeholder="Bot Greeting"
          type="text"
          label="Bot Greeting"
          flat
        ></v-textarea>

        <!-- <v-textarea
          v-model="form.conv_end"
          placeholder="Conversation End"
          type="text"
          label="Conversation End"
          flat
        ></v-textarea> -->

        <v-switch v-model="form.use_nlp" :label="`Use NLP: ${form.use_nlp.toString()}`"></v-switch>
        <v-switch v-model="form.use_llm" :label="`Use LLm: ${form.use_llm.toString()}`"></v-switch>
        <!-- {{ disabledDialects }} -->
    </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="!form.name.trim().length"
        :loading="addButtonLoader"
        color="primary"
        @click="addBot"
      >
        {{ action }}
      </v-btn>
      <v-btn outline @click="$emit('closeDialog')"> close </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import languagesWithDialects, { languages } from "../../data/languagesWithDialects";
import imageInput from "../block-build/blocks/block-cards/common-inner-blocks/image-uploader-dropzone";
import Voices from "../voice/voices.vue";
export default {
  name: "botAddDialog",
  components: {
    imageInput,
    Voices,
  },
  props: {
    bot: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.initializeBot();
  },
  data() {
    return {
      form: {
        name: "",
        image: "",
        voice_id: "",
        speed: 0.5,
        language: [],
        dialect: [],
        assistant_type: 'voice',
        ai_greeting: '',
        // conv_end: '',
        use_nlp: false,
        use_llm: true,
      },
      action: "Create",
      addButtonLoader: false,
      languages: languages
    };
  },
  computed: {
    userId() {
      return this.$store.state.user.userData.id;
    },
    dialects() {
      //   const languages = form.getValues('language')
      const languages = this.form.language;
      const dialects = languagesWithDialects.filter(({lang_code}) => languages && languages.includes(lang_code))
        .map(({dialects}) => dialects && dialects.map(({dialect, dialect_code}) => ({
          text: dialect,
          value: dialect_code,
          // disabled: function (item){
          //   console.log('disabled', this.disabledDialects)
          //   return true
          //   // return this.disabledDialects.includes(dialect_code)
          // }
        })))
      return dialects.flat()
    },
    disabledDialects() {
      const selectedDialects = this.form.dialect;
      //disable all dialects has same language prefix like en- or ar- except the selected ones
      const disabled = this.dialects.filter(({value}) => {
        const prefix = value.split('-')[0]
        return !selectedDialects.includes(value) && selectedDialects.some((dialect) => dialect.startsWith(prefix))
      }).map((v) => v.value);
      return disabled
      
    },
  },
  watch: {
    bot(){
      this.initializeBot();
    },
  },
  methods: {
    initializeBot(){
      if(Object.keys(this.bot).length > 0) {
        this.action = "Update";
        this.form.name = this.bot.title;
        this.form.image = this.bot.image;
        // const userId = this.$store.state.user.userData.id;
        this.$http_voice.get(`/agents/${this.bot.id}`)
          .then(({data}) => {
           // console.log(data.data);
            if(Object.keys(data.data).length > 0) {
              this.form = {
                ...this.form,
                ...data.data
              };
            }else{
              this.form = {
                name: "",
                image: "",
                voice_id: "",
                speed: 0.5,
                language: [],
                dialect: [],
                assistant_type: 'voice',
                ai_greeting: '',
                // conv_end: '',
                use_nlp: false,
                use_llm: true,
              };
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    async addBot() {
      console.log(this.form,this.$store.state.user.userData.id);
      // return ;
      this.addButtonLoader = true;
      let response;
      let botId =  null;
      if(this.action === "Update") {
        response = await this.$http.put(`/bot/${this.bot.id}`, this.form);
        botId = this.bot.id;
        console.log('botId', botId);
      }else{
        response = await this.$http.post(`/users/bot`, this.form);
        botId = response.data.bot_id;
      }
      const userId = this.$store.state.user.userData.id;
      await this.$http_voice.post(`/agents/${botId}/accounts/${userId}`, {
        ...this.form,
        bot_name: this.form.name,
      });

      this.addButtonLoader = false;
      this.form.name = "";
      this.form.image = "";
      this.$emit("closeDialog");
      this.$emit("reloadBots");
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 2000);
    },
    updateImageUrl(e) {
      this.form.image = e;
    },
  },
};
</script>

<style scoped>
:deep(.v-input--slider  .v-input__slot)  {
  padding-right: 12px !important;
}
</style>
